import { fetchDivisions } from '@/shared/api';
import _ from 'lodash';

/**
 * Shapes a raw list of country subdivisions into state or province select options. Maps each division to a label from its name, a value from its code and its fullCode.
 *
 * @param divisions - Subdivision records to convert into options.
 * @returns Array of division option objects.
 */
export const divisionsFormatter = (divisions: any) =>
  _.map(divisions, (division) => ({
    label: division.name,
    value: division.code,
    fullCode: division.fullCode,
  }));

/**
 * Loads the state or province options for a country, alphabetically ordered. Fetches the divisions for the country code, orders them ascending by name and maps them to label, value and fullCode options, logging the failure and returning an empty list when the request throws.
 *
 * @param countryCode - Two-letter country code whose subdivisions are loaded.
 * @returns Promise resolving to the name-ordered division options, or an empty array on failure.
 */
export const handleFetchDivisions = async (countryCode: any) => {
  try {
    const divisionsResult = await fetchDivisions(countryCode);
    const { data } = divisionsResult;
    const { divisions } = data;
    const formattedDivisions = divisionsFormatter(_.orderBy(divisions, ['name'], ['asc']));
    return formattedDivisions;
  } catch (error) {
    console.error('Failed to fetch divisions: ', error);
    return [];
  }
};
